module.exports = __webpack_public_path__ + "static/media/bb.0b8c3885.png";